(function () {
  'use strict';

  var progressBar = null;
  var stickyBar = null;
  var topBar = null;
  var lastScrollY = 0;
  var ticking = false;
  var item1Visible = false;
  var item10Visible = false;
  var pastItem1 = false;
  var pastItem10 = false;

  function init() {
    progressBar = document.querySelector('.rwl__progress-fill');
    stickyBar = document.querySelector('.rwl__sticky-bar');
    topBar = document.querySelector('.rwl__top-bar');

    // Hide site header and footer
    hideNavAndFooter();

    // Observe item 1 and item 10 for sticky bar visibility
    initStickyBarObservers();

    // Scroll listener for progress bar + header hide
    if (progressBar || topBar) {
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  function hideNavAndFooter() {
    var selectors = [
      '#shopify-section-header',
      '#shopify-section-footer',
      '#shopify-section-announcement-bar',
      'header.header',
      'footer.footer',
      '.section-header',
      '.section-footer'
    ];
    selectors.forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) el.style.display = 'none';
    });
  }

  function initStickyBarObservers() {
    if (!stickyBar) return;

    var item1 = document.getElementById('rwl-item-1');
    var item10 = document.getElementById('rwl-item-10');
    if (!item1 || !item10) return;

    // Observer for item 1 — sticky bar appears after scrolling past it
    var item1Observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        item1Visible = entry.isIntersecting;
        var rect = entry.boundingClientRect;
        pastItem1 = rect.bottom < 0;
        updateStickyBar();
      });
    }, { threshold: 0 });

    // Observer for item 10 — sticky bar hides after scrolling past it
    var item10Observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        item10Visible = entry.isIntersecting;
        var rect = entry.boundingClientRect;
        pastItem10 = rect.bottom < 0;
        updateStickyBar();
      });
    }, { threshold: 0 });

    item1Observer.observe(item1);
    item10Observer.observe(item10);
  }

  function updateStickyBar() {
    if (!stickyBar) return;
    // Show sticky bar: after item 1 leaves viewport, until item 10 leaves viewport
    var shouldShow = (pastItem1 || !item1Visible) && !pastItem10;
    // But don't show if we haven't scrolled past item 1 at all
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var item1 = document.getElementById('rwl-item-1');
    if (item1 && scrollTop < item1.offsetTop + item1.offsetHeight) {
      shouldShow = false;
    }
    stickyBar.classList.toggle('rwl__sticky-bar--visible', shouldShow);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  function update() {
    ticking = false;

    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var docHeight = document.documentElement.scrollHeight - window.innerHeight;
    if (docHeight <= 0) return;

    var scrollPercent = (scrollTop / docHeight) * 100;

    // Update reading progress bar
    if (progressBar) {
      progressBar.style.width = Math.min(scrollPercent, 100) + '%';
    }

    // Collapse banner on scroll, only expand at very top
    if (topBar) {
      if (scrollTop > 50) {
        topBar.classList.add('rwl__top-bar--collapsed');
      } else {
        topBar.classList.remove('rwl__top-bar--collapsed');
      }
    }

    // Update sticky bar based on scroll position
    updateStickyBar();

    lastScrollY = scrollTop;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
